<div class="container  " *ngIf="this.nextConfig.layout === 'horizontal' && this.nextConfig.subLayout === 'horizontal-2'; else mainHeader" (window:resize)="onResize($event)">
    <ng-container *ngTemplateOutlet="mainHeader"></ng-container>
</div>
<ng-template #mainHeader>

    <div class="m-header ">
        <a class="b-brand">
            <div class="logo-img">
                <img src="/assets/img/logo-implementos.png" />
            </div>
            <span class="b-title" style="color:white; font-size: 20px; font-weight: bold;">Implementos</span>
        </a>
        <div *ngIf="windowWidth <= 768">
            <app-nav-right></app-nav-right>
        </div>
    </div>

    <div class="collapse navbar-collapse" [style.display]="this.collapseStyle" (window:resize)="onResize($event)">
        <app-nav-right class="ml-auto" *ngIf="windowWidth > 426"></app-nav-right>
    </div>
</ng-template>